import React, { Component } from "react";
import { Button } from "@blueprintjs/core";
import InputText from "../../blueprintWrappers/InputText";
import TaskStatusSelector from "../TaskStatusSelector";
import { TASK_STATUS_OPTIONS, TASK_STATUS, TASK_STATUS_COLOR } from "../constants";
import { connect } from 'react-redux';
import { actions } from '../../../config/reduxIndex';
import SelectWrapper from '../../blueprintWrappers/SelectWrapper';
import { optionFactory } from "../../shared/optionFactory";
import EditableDetail from "./EditableDetail";
import IconSmallButton from "../../blueprintWrappers/IconSmallButton";
import FileDropzoneContainer from "../../../containers/projectmanager/FileDropzoneContainer";
import PMAssignmentSection from "./PMAssignmentSection";
import SubTaskNotEditable from "./TaskGroup/SubTaskNotEditable";
import moment from 'moment-timezone';
import CalendarInputWithButton from "../../blueprintWrappers/CalendarInputWithButton";
import { makeRandomString } from "../../../utilities/Utility";

export const HIDDEN_FIELDS = [
	'parentID',
	'phaseID',
	'bp',
	'phase',
	'project',
	'subTasks',
	'uniqueID',
	'assigned'
]

class PMTaskOverlay extends Component {

	state = {
		fields: null,
		saved: true,
		currentItem: null,
		newHoursLine: {
			uniqueID: '',
			workDate: '',
			addedDate: '',
			createdBy: '',
			hours: '0',
			planned: '0',
			billable: '0',
			billed: '0',
			note: '',
			internal: ''
		},
		newCommentLine: {
			uniqueID: '',
			author: '',
			createdBy: '',
			date: '',
			time: '',
			comment: ''
		},
		newSubTaskLine: {
			uniqueID: '',
			createdBy: '',
			title: '',
			comment: '',
			checked: ''
		}
	}

	componentWillMount() {
		this.retrieveAndFilter();
		this.retrieveHourLines();
		this.retrieveSubTasks();
		this.retrieveComments();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;
		let cur = p.reduxData.temp;
		let assignedUsers = p.reduxData.storedUsers.filter(isAssigned);

		this.setState({
			fields: Object.entries(cur),
			currentItem: cur,
			assignedUsers: assignedUsers,
		})

		function isAssigned(usr) {
			let result = false;
			if (cur.assigned.includes(usr.uniqueID)) {
				result = true;
			}
			return result;
		}

	}

	retrieveHourLines = () => {
		const p = this.props;
		let cur = p.reduxData.temp;
		p.getHours(cur.uniqueID);
	}

	retrieveSubTasks = () => {
		const p = this.props;
		let cur = p.reduxData.temp;
		p.getSubTasks(cur.uniqueID);
	}

	retrieveComments = () => {
		const p = this.props;
		let cur = p.reduxData.temp;
		p.getComments(cur.uniqueID);
	}

	render() {
		const { currentItem, assignedUsers } = this.state;

		let statusProps = {
			onChange: this.onChange,
			value: currentItem.status,
			returnObj: this.createReturnObj('status')
		}

		return (
			<div className="bp__edit pm_task_popover pt-card">
				<div className="subpage_wrapper" >

					{this.buttons()}

					<div className="TaskTitleAndStatus">
						<div className="TaskTitleAndStatusLeft">
							<EditableDetail
								property={"display"}
								value={currentItem.display}
								onChange={this.onChangeAlt}
								onSave={this.onChangeAlt}
							/>
						</div>
						<div className="TaskTitleAndStatusRight">
							<h3>Status</h3>
							<SelectWrapper
								{...statusProps}
							>
								{this.statusOptions()}
							</SelectWrapper>
						</div>
					</div>

					<div className={"TaskLineBreak"}></div>

					<div className="TaskDetail">
						<div className="TaskLeft">
							<h3>Description:</h3>

						</div>

						<div className="TaskRight">
							<EditableDetail
								small
								property={"description"}
								value={currentItem.description}
								onChange={this.onChangeAlt}
								onSave={this.onChangeAlt}
							/>
						</div>
					</div>

					<div className={"TaskLineBreak"}></div>

					<div className="TaskDetail" /* subtasks */ >
						<div className="TaskLeft">
							<h3>Subtasks:</h3>


						</div>
						<div className="TaskRight">
							{this.subtasks()}
						</div>
					</div>

					<div className={"TaskLineBreak"}></div>

					<div className="TaskDetail" /* comments */ >
						<div className="TaskLeft">
							<h3>Comments:</h3>

						</div>

						<div className="TaskRight">

							{this.comments()}

						</div>
					</div>

					<div className={"TaskLineBreak"}></div>

					<div className="TaskDetail" /* Hours */ >
						<div className="TaskLeft">
							<h3>Hours:</h3>

						</div>

						<div className="TaskRight">
							{this.hours()}
						</div>
					</div>

					<div className={"TaskLineBreak"}></div>

					<div className="TaskDetail" /* users */ >
						<div className="TaskLeft">
							<h3>Users:</h3>

						</div>

						<div className="TaskRight">
							<PMAssignmentSection
								users={assignedUsers}
								header={""}
								addAssigned={this.addAssigned}
								removeAssigned={this.removeAssigned}
							/>
						</div>
					</div>

					<div className={"TaskLineBreak"}></div>

					<div className="TaskDetailAttachments" /* attachments */ >
						<div className="TaskLeft">
							<h3>Attachments:</h3>
						</div>
						<div className="TaskRight">
							<FileDropzoneContainer />
						</div>
					</div>

				</div>
			</div>
		)
	}

	createReturnObj = (attr) => {
		return { attr };
	}

	statusOptions = () => {
		const opts = TASK_STATUS_OPTIONS
		return optionFactory(opts);
	}

	onChange = (value, obj) => {
		console.log('onChange');
		console.log(value);
		console.log(obj);
		let newCurrent = this.props.reduxData.temp;
		newCurrent[obj.attr] = value;
		this.props.setAttributeByObj({
			temp: newCurrent
		});

		this.setState({
			saved: false
		})
	}

	onChangeAlt = (value, attr) => {
		let newCurrent = this.props.reduxData.temp;
		newCurrent[attr] = value;
		this.props.setAttributeByObj({
			temp: newCurrent
		});

		this.setState({
			saved: false
		})
	}

	onChangeNotes = (e) => {
		const attr = e.target.getAttribute('attr');
		let newTemp = this.props.reduxData.temp;
		newTemp[attr] = e.target.value;

		this.props.setAttributeByObj({
			temp: newTemp
		});

		this.setState(function () {
			return {
				saved: false,
			}
		});
	}

	isNotHiddenField = (field) => {
		let result = true;
		HIDDEN_FIELDS.forEach(h => {
			if (h === field[0]) {
				result = false;
			}
		});
		return result;
	}

	buttons = () => {
		const btnStyle = { // TODOCSS
			'textAlign': 'center',
		}
		return <div className="projectmanager_button_row" style={btnStyle}>
			<Button
				large
				icon="pin"
				title="Save"
				intent="primary"
				onClick={this.onSave}
			>
				Save
			</Button>

			<Button
				large
				icon="pin"
				title="Cancel"
				intent="primary"
				onClick={this.onCancel}
			>
				Cancel
			</Button>
		</div>
	}

	onSave = () => {
		this.setState({
			saved: true
		})

		switch (this.props.reduxData.overlayEditType) {
			case 'task':
				this.props.addTask(this.props.reduxData.temp);
				break;
			case 'task-edit':
				this.props.updateTask(this.props.reduxData.temp);
				break;
			default:
				console.log("no overlayEditType set");
		}

		this.props.closeOverlay();
	}

	onCancel = () => {
		this.props.setAttributeByObj({
			temp: null,
			overlayEditType: 'none'
		});
		this.props.closeOverlay();
	}

	addAssigned = (e) => {
		let newTask = Object.assign({}, this.state.currentItem);
		newTask.assigned = [...newTask.assigned, e.uniqueID];
		this.props.updateTask(newTask);
	}

	removeAssigned = (user) => {
		let newTask = Object.assign({}, this.state.currentItem);
		newTask.assigned = newTask.assigned.filter(usr => usr !== user.uniqueID);
		this.props.setAttributeByObj({
			temp: newTask
		});
	}

	subtasks = () => {
		const p = this.props;
		const { currentUser, storedSubTasks } = p.reduxData;
		const { newSubTaskLine } = this.state;

		if (storedSubTasks.length === 0) {
			return (
				<div className={"SubTasks"}>
					"No Subtasks have been created."
					<IconSmallButton
						iconName="plus"
						title={"add subtask"}
						onClick={this.addSubTask}
					/>

					<InputText
						onChange={this.onChangeNewSubTask}
						value={newSubTaskLine.title}
						returnObj={{ attr: "title" }}
						placeholder={"Title"}
					/>
					<InputText
						onChange={this.onChangeNewSubTask}
						value={newSubTaskLine.comment}
						returnObj={{ attr: "comment" }}
						placeholder={"Comment"}
					/>
				</div>
			)
		}

		return (
			<div className={"SubTasks"} >

				<IconSmallButton
					iconName="plus"
					title={"add subtask"}
					onClick={this.addSubTask}
				/>

				<InputText
					onChange={this.onChangeNewSubTask}
					value={newSubTaskLine.title}
					returnObj={{ attr: "title" }}
					placeholder={"Title"}
				/>
				<InputText
					onChange={this.onChangeNewSubTask}
					value={newSubTaskLine.comment}
					returnObj={{ attr: "comment" }}
					placeholder={"Comment"}
				/>


				{storedSubTasks.map((st, index) => {
					return (
						<div className={st.createdBy === currentUser ? "SubTasksLineSelf" : "SubTasksLine"} key={'_subtask_' + index}>
							<SubTaskNotEditable
								subtask={st}
								index={index}
								key={st.uniqueID + '_subtask_title' + index}
								toggleCheck={this.toggleCheck}
								removeSubtask={this.removeSubtask}
							/>

						</div>
					)
				})}
			</div>
		)
	}

	toggleCheck = (subtask) => {
		const p = this.props;

		let temp = Object.assign({}, subtask);
		temp.checked = !subtask.checked;

		p.updateSubTask(temp);
	}

	addSubTask = () => {
		const p = this.props;
		const { currentUser } = p.reduxData;
		const { newSubTaskLine, currentItem } = this.state;

		let temp = Object.assign({}, newSubTaskLine);
		temp.parentID = currentItem.uniqueID;
		temp.uniqueID = makeRandomString(24);
		temp.createdBy = currentUser;
		temp.addedDate = moment(new Date()).format('MM/DD/YYYY');

		p.saveSubTask(temp);

		this.setState({
			saved: false,
			newSubTaskLine: {
				uniqueID: '',
				createdBy: '',
				title: '',
				comment: '',
				checked: ''
			}
		})

		this.retrieveSubTasks();
	}

	removeSubtask = (e) => {
		const p = this.props;
		let newSubTask = Object.assign({}, e);
		newSubTask.parentID = 'removed';

		p.removeSubTask(newSubTask);

		this.setState({
			saved: false
		})
	}

	onChangeNewSubTask = (value, returnObj) => {
		let newSubTask = Object.assign({}, this.state.newSubTaskLine);
		newSubTask[returnObj.attr] = value;
		this.setState({
			newSubTaskLine: newSubTask,
		})
	}

	comments = () => {
		const p = this.props;
		const { currentUser, storedUsers, storedCommentLines } = p.reduxData;
		const { currentItem, newCommentLine } = this.state;

		return (
			<div className={"TaskComments"} >
				{storedCommentLines.map((comment, index) => {
					return (
						<div className={comment.createdBy === currentUser ? "TaskCommentLine" : "TaskCommentLineLeft"} key={'_comment_' + index}>

							{comment.comment}

							<div className={comment.createdBy === currentUser ? "TaskCommentDetails" : "TaskCommentDetailsLeft"}>
								{getUserName(comment.createdBy)} - {comment.date} - {comment.time}
							</div>

						</div>
					)
				})}

				<div className={"TaskComments"} onKeyPress={this.handleKeyPress} >
					<InputText
						onChange={this.onChangeNewComment}
						value={newCommentLine.comment}
						returnObj={{ attr: "comment" }}
						placeholder={"Add a new comment"}
					/>
					<IconSmallButton
						iconName="plus"
						title={"add Comment"}
						onClick={this.addCommentLine}
					/>
				</div>

			</div>
		)

		function getUserName(createdBy) {
			let loc = storedUsers.findIndex(indexOfUser);

			if (loc > -1) {
				return (storedUsers[loc].firstName + ' ' + storedUsers[loc].lastName.substring(0, 1));
			} else {
				return ' '
			}

			function indexOfUser(usr) {
				return usr.uniqueID === createdBy;
			}
		}
	}


	onChangeNewComment = (value, returnObj) => {
		let newComment = Object.assign({}, this.state.newCommentLine);
		newComment[returnObj.attr] = value;
		this.setState({
			newCommentLine: newComment,
		})
	}

	addCommentLine = () => {
		const p = this.props;
		const { currentUser, storedUsers } = p.reduxData;
		const { newCommentLine, currentItem } = this.state;

		let temp = Object.assign({}, newCommentLine);
		temp.parentID = currentItem.uniqueID;
		temp.uniqueID = makeRandomString(24);
		temp.createdBy = currentUser;
		temp.author = getUserName(currentUser);
		temp.date = moment(new Date()).format('MM/DD/YYYY');
		temp.time = new moment().format("HH:mm A");

		p.saveComment(temp);

		this.setState({
			saved: false,
			newCommentLine: {
				uniqueID: '',
				author: '',
				createdBy: '',
				date: '',
				time: '',
				comment: ''
			}
		})

		this.retrieveComments();

		function getUserName(createdBy) {
			let loc = storedUsers.findIndex(indexOfUser);
			if (loc > -1) {
				return (storedUsers[loc].firstName + ' ' + storedUsers[loc].lastName.substring(0, 1));
			} else {
				return ' '
			}
			function indexOfUser(usr) {
				return usr.uniqueID === createdBy;
			}
		}
	}

	handleKeyPress = (event) => {
		if (event.key == 'Enter') {
			this.addCommentLine()
		}
	}

	removeCommentLine = (e) => {
		let newTask = Object.assign({}, this.state.currentItem);
		newTask.comments = newTask.comments.filter(hl => hl.uniqueID !== e.uniqueID);
		this.setState({
			currentItem: newTask,
			saved: false
		})
	}

	hours = () => {
		const p = this.props;
		const { storedUsers, storedHourLines } = p.reduxData;
		const { newHoursLine } = this.state;

		function getUserName(createdBy) {
			let loc = storedUsers.findIndex(indexOfUser);
			if (loc > -1) {
				return (storedUsers[loc].firstName + ' ' + storedUsers[loc].lastName.substring(0, 1));
			} else {
				return ' '
			}
			function indexOfUser(usr) {
				return usr.uniqueID === createdBy;
			}
		}

		if (storedHourLines == null) {
			return null
		}

		return (
			<div className={"PMHours"} >

				{storedHourLines.map((line, index) => {
					return (
						<div className={"PMHoursLine"} key={'_hourline_' + index}>
							<b>Hours: {line.hours}</b> | {line.note}
							{line.billable !== 0 ? " Billable: " + line.billable : null}
							{this.internalNotesPermission() && line.internal != null ? ' internal: ' + line.internal : null}
							<div className={"PMHoursLineDetails"}>
								{getUserName(line.createdBy)} | {line.workDate} | {line.addedDate}

								<IconSmallButton
									iconName="minus"
									title={"remove Hours"}
									onClick={() => this.removeHoursLine(line)}
								/>

							</div>

						</div>
					)
				})}

				<div>
					<IconSmallButton
						iconName="plus"
						title={"add Hours"}
						onClick={this.addHoursLine}
					/>

					<InputText
						onChange={this.onChangeNewHours}
						value={newHoursLine.note}
						returnObj={{ attr: "note" }}
						placeholder={"Invoice Note"}
					/>
					<InputText
						onChange={this.onChangeNewHours}
						value={newHoursLine.hours}
						returnObj={{ attr: "hours" }}
						placeholder={"Hours"}
					/>
					<InputText
						onChange={this.onChangeNewHours}
						value={newHoursLine.billable}
						returnObj={{ attr: "billable" }}
						placeholder={"Billable Hours"}
					/>
					<CalendarInputWithButton
						value={newHoursLine.workDate}
						onChange={this.onChangeNewHours}
						returnObj={{ attr: 'workDate' }}
					/>
					<InputText
						onChange={this.onChangeNewHours}
						value={newHoursLine.internal}
						returnObj={{ attr: "internal" }}
						placeholder={"Internal Comments (optional)"}
					/>
				</div>


			</div>
		)
	}

	internalNotesPermission = () => { // TODO1 
		const { currentUserRole } = this.props;
		if (currentUserRole != 'Dev')
			return true;
		else
			return false;
	}

	onChangeNewHours = (value, returnObj) => {
		let newHours = Object.assign({}, this.state.newHoursLine);
		newHours[returnObj.attr] = value;
		this.setState({
			newHoursLine: newHours,
		})
	}

	addHoursLine = () => {
		const p = this.props;
		const { currentUser } = p.reduxData;
		const { newHoursLine, currentItem } = this.state;

		let temp = Object.assign({}, newHoursLine);
		temp.parentID = currentItem.uniqueID;
		temp.uniqueID = makeRandomString(24);
		temp.createdBy = currentUser;
		temp.addedDate = moment(new Date()).format('MM/DD/YYYY');

		p.saveHourLines(temp);

		this.setState({
			saved: false,
			newHoursLine: {
				uniqueID: '',
				workDate: '',
				addedDate: '',
				createdBy: '',
				hours: '0',
				planned: '0',
				billable: '0',
				billed: '0',
				note: '',
				internal: ''
			}
		})

		this.retrieveHourLines();

	}

	removeHoursLine = (e) => {
		const p = this.props;
		let newLine = Object.assign({}, e);
		newLine.parentID = 'removed';

		p.removeHourLine(newLine);

		this.setState({
			saved: false
		})
	}
}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		addTask: (obj) => {
			dispatch(actions.pm.addTask(obj))
		},
		updateTask: (obj) => {
			dispatch(actions.pm.updateTask(obj))
		},
		saveHourLines: (obj) => {
			dispatch(actions.pm.saveHourLines(obj))
		},
		removeHourLine: (obj) => {
			dispatch(actions.pm.removeHourLine(obj))
		},
		updateProject: (obj) => {
			dispatch(actions.pm.updateProject(obj))
		},
		getHours: (obj) => {
			dispatch(actions.pm.getHourLines(obj))
		},
		getSubTasks: (obj) => {
			dispatch(actions.pm.getSubTasks(obj))
		},
		saveSubTask: (obj) => {
			dispatch(actions.pm.saveSubTask(obj))
		},
		removeSubTask: (obj) => {
			dispatch(actions.pm.removeSubTask(obj))
		},
		updateSubTask: (obj) => {
			dispatch(actions.pm.updateSubTask(obj))
		},
		closeOverlay: () => {
			dispatch(actions.globalState.closeOverlay());
		},
		getComments: (obj) => {
			dispatch(actions.pm.getComments(obj))
		},
		saveComment: (obj) => {
			dispatch(actions.pm.saveComment(obj))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMTaskOverlay);


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMTaskOverlay.js